import { Button } from '@/components/ui/Button'
import { Textarea } from '@/components/ui/Textarea'
import { cn } from '@/lib/utils'

// The submit page's left column, GitHub's "Add a description": one message
// box (required — the reviewer reads it as the description of the work) and
// the Cancel / Submit pair. Label, hint and verb come from the page, which
// knows whether a reviewer is involved.
export default function SubmitMessageCard({
  label,
  placeholder,
  hint,
  warning = false,
  message,
  onChange,
  submitLabel,
  onSubmit,
  onCancel,
  disabled = false,
}: {
  label: string
  placeholder: string
  hint?: string | null
  /** Show the hint in the warning tone (this submit publishes right away). */
  warning?: boolean
  message: string
  onChange: (value: string) => void
  submitLabel: string
  onSubmit: () => void
  onCancel: () => void
  /** Extra condition beyond the message being non-blank, e.g. no one picked yet. */
  disabled?: boolean
}) {
  const ready = message.trim().length > 0

  return (
    <div
      style={{ background: 'var(--background)', borderColor: 'var(--border)' }}
      className="flex flex-col gap-3 rounded-lg border p-5"
    >
      <label htmlFor="submit-message" className="text-base font-semibold text-foreground">{label}</label>
      <Textarea
        id="submit-message"
        rows={8}
        className="min-h-40 focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:border-chart-muted"
        value={message}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoFocus
      />
      {hint && (
        <p className={cn('text-[13px]', warning ? 'text-warning' : 'text-muted-foreground')}>{hint}</p>
      )}
      <div className="flex justify-end gap-2">
        <Button variant="outline" size="sm" onClick={onCancel}>Cancel</Button>
        <Button size="sm" disabled={disabled || !ready} onClick={onSubmit}>{submitLabel}</Button>
      </div>
    </div>
  )
}
